import { Component, OnInit } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

import { CancelBlockedSlotSuccessAction } from '../../+store/court-event-modals.actions';
import { CourtEventModalsFacade } from '../../+store/court-event-modals.facade';
import { CancelBlockedSlotMode } from '../../+store/court-event-modals.state.model';
import { BlockedSlotCancelInputModel } from '../../models/blocked-slot-cancel-input.model';


@Component({
    selector: 'app-blocked-slot-cancel-reason-modal',
    templateUrl: './blocked-slot-cancel-reason-modal.component.html',
    styleUrls: ['./blocked-slot-cancel-reason-modal.component.scss'],
    standalone: false
})
export class BlockedSlotCancelReasonModalComponent implements OnInit {
    form: UntypedFormGroup;
    isLoading$ = this.courtEventModalsFacade.isCancelBlockedSlotFormLoading$;
    isFormValid$ = this.courtEventModalsFacade.isCancelBlockedSlotFormValid$;

    public input: BlockedSlotCancelInputModel;

    cancelMode = CancelBlockedSlotMode;

    private subscriptions: Subscription = new Subscription();
    constructor(
        public bsModalRef: BsModalRef,
        private formBuilder: UntypedFormBuilder,
        private courtEventModalsFacade: CourtEventModalsFacade,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            reason: [null],
            cancelMode: [CancelBlockedSlotMode.thisEvent]
        });

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(CancelBlockedSlotSuccessAction)).subscribe(() => {
                this.bsModalRef.hide();
            })
        );
    }

    onSave(): void {
        this.courtEventModalsFacade.cancelBlockedSlot(this.input.blockedSlotId);
    }
}
